export async function getLocationDetail(lat, lon) {
    if (!lat || !lon) return null;
  
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;
  
    const res = await fetch(url, {
      headers: {
        "Accept": "application/json",
        "User-Agent": "YourAppName (your@email.com)"
      }
    });
  
    if (!res.ok) {
      console.error("Reverse geocode failed");
      return null;
    }
  
    const data = await res.json();
  
    return {
      lat: data.lat,
      lon: data.lon,
      displayName: data.display_name,
      address: data.address || {},
      raw: data
    };
  }
  